import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rootContainer: {
    display: 'flex',
    gap: theme.spacing(4),
    padding: theme.spacing(4, 5),
  },
  leftContainer: {
    width: '75%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  accountNameContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  createdByContainer: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0px',
  },
  accountName: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.select.light,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.1px',
  },
  cloudAccountIdContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  cloudIcon: {
    height: theme.spacing(3),
    width: theme.spacing(3),
  },
  cloudAccountId: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.25px',
  },
  rightContainer: {
    width: '25%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  activityLogContainer: {
    backgroundColor: theme.palette.text.white,
    borderRadius: theme.spacing(1),
    height: theme.spacing(31.75),
  },
  activityLogContent: {
    padding: theme.spacing(4),
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  heading: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.15px',
  },
  labraIcon: {
    height: theme.spacing(9.75),
    width: theme.spacing(26.75),
  },
  svgBackground: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(20),
  },
  removeModalContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  removeModalHeading: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.25px',
  },
  trashIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(2.5),
  },
}))
